var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExhibitorPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 2.08337H18.3334V5.41671L17.7509 5.76671C17.2976 6.03869 16.7789 6.18236 16.2502 6.18236C15.7216 6.18236 15.2029 6.03869 14.7496 5.76671L14.1667 5.41671L13.5842 5.76671C13.1309 6.03869 12.6122 6.18236 12.0836 6.18236C11.5549 6.18236 11.0362 6.03869 10.5829 5.76671L10 5.41671L9.41752 5.76671C8.96422 6.03869 8.44553 6.18236 7.9169 6.18236C7.38826 6.18236 6.86957 6.03869 6.41627 5.76671L5.83335 5.41671L5.25044 5.76671C4.79719 6.03861 4.27857 6.18224 3.75002 6.18224C3.22147 6.18224 2.70285 6.03861 2.2496 5.76671L1.66669 5.41671V2.08337Z",
    fill: "#572148",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.66675V10.4167M16.25 6.66675V10.4167M2.5 10.4167H17.5V17.9167H2.5V10.4167Z",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitorPortal);
export default __webpack_public_path__ + "static/media/exhibitor-portal.ac3eb94fe8cfa5ff9d1e62076e30ab11.svg";
export { ForwardRef as ReactComponent };